import { motion } from 'framer-motion'
import SectionTitle from '../ui/SectionTitle'

const VALUES = [
  { icon: '🛡️', title: 'Safety First',     desc: 'Kid-friendly team and safe activities — parents can relax.',   color: '#FF6BB5' },
  { icon: '🎨', title: 'Creativity',        desc: 'Unique themes and magical experiences for every celebration.',  color: '#7C3AFF' },
  { icon: '😊', title: 'Joy',               desc: 'Creating smiles and lasting memories that families cherish.',   color: '#FFC300' },
  { icon: '⭐', title: 'Professionalism',   desc: 'Reliable service you can trust — we always deliver.',           color: '#22C55E' },
]

const containerVariants = {
  hidden: {},
  show:   { transition: { staggerChildren: 0.12 } },
}

const itemVariants = {
  hidden: { opacity: 0, y: 24 },
  show:   { opacity: 1, y: 0, transition: { duration: 0.55, ease: 'easeOut' } },
}

export default function WhatWeBelieve() {
  return (
    <section className="section-padding bg-gradient-pink">
      <div className="container-custom">
        <SectionTitle
          eyebrow="Our Values"
          title="What We Believe"
          subtitle="The principles that guide everything we do."
        />

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: '-60px' }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6"
        >
          {VALUES.map(({ icon, title, desc, color }) => (
            <motion.div
              key={title}
              variants={itemVariants}
              whileHover={{ y: -6 }}
              className="bg-surface rounded-3xl p-8 shadow-card hover:shadow-glow-primary transition-all duration-300 text-center"
            >
              {/* Icon in colored circle */}
              <div
                className="w-16 h-16 rounded-full mx-auto mb-5 flex items-center justify-center text-3xl"
                style={{ backgroundColor: `${color}18`, border: `2px solid ${color}30` }}
              >
                {icon}
              </div>

              <h3 className="font-display text-ink text-lg mb-3">{title}</h3>
              <p className="font-body text-ink-muted text-sm leading-relaxed">{desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  )
}
